import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {UseServicesGuideQueryParams} from './types';
import {getServicesGuide} from '../../services/getServicesGuide';

export function useServicesGuideQuery({type, cdUf, nmCidade}: UseServicesGuideQueryParams) {
	return useQuery({
		queryKey: [QUERY_KEYS.SERVICES_GUIDE, type, cdUf, nmCidade],
		queryFn: ({signal}) =>
			getServicesGuide({
				type,
				cdUf,
				nmCidade,
				signal,
			}),
		enabled: !!(cdUf && nmCidade),
	});
}
